/** ----------------------------------------
    Form
 ---------------------------------------- */

export class StickySide {
    constructor(el) {
        this.el = el;

        if (!this.el) return;

        this.sticky = this.el.querySelector('.sticky');
        this.extendableListElems = document.querySelectorAll('.details__section--extendable-list');

        this.init();
    }

    resetSticky() {
        [...this.extendableListElems].forEach(el => {
            el.classList.remove('list-closed');
        });

        this.useExtendableList = (this.sticky.offsetHeight > window.innerHeight - 140);
    }

    updateStickyPosition() {
        this.stickyPosition = (this.sticky.offsetHeight > window.innerHeight - 140) ? 'bottom' : 'top';
        this.el.classList.remove('side--sticky-top');
        this.el.classList.remove('side--sticky-bottom');
        this.el.classList.add(`side--sticky-${ this.stickyPosition }`);
    }

    setExtendableListState() {
        [...this.extendableListElems].forEach(el => {
            if (this.useExtendableList) {
                el.classList.add('use-extendable');
                
                if (this.stickyPosition === 'bottom') {
                    el.classList.add('list-closed');
                    this.updateStickyPosition(this.sticky);
                }
            } else {
                el.classList.remove('use-extendable');
            }
        });
    }

    setResizeEvent() {
        window.onresize = () => {
            this.resetSticky();
            this.updateStickyPosition();
            this.setExtendableListState();
        };
    }

    setExtendableListEvents() {
        [...this.extendableListElems].forEach(el => {
            const title = el.querySelector('.details__title');
    
            title.addEventListener('click', () => {
                if (this.useExtendableList) {
                    el.classList.toggle('list-closed');
                    this.updateStickyPosition(this.sticky);
                }
            });
        });
    }

    /** ----------------------------------------
        Init
     ---------------------------------------- */

    init() {
        this.resetSticky();
        this.setResizeEvent();
        this.updateStickyPosition();
        this.setExtendableListState();
        this.setExtendableListEvents();
    }
}